<div class="header">
   <div class="cabezote d-flex">
      <div class="container">
         <div class="row">
            <div class="col-8 col-sm-6 col-md-4 col-lg-4 logo">
              <a href="index.html">
                <img src="assets/images/logo-vue.png" alt="Ventanilla Única Empresarial" title="Ventanilla Única Empresarial"/>
              </a>
            </div>
            <div class="col-8 col-sm-13 col-md-15 col-lg-15 d-flex justify-content-end">
              <span class="col-24 d-flex align-self-center justify-content-end">
                {{currentDate}}
              </span>
            </div>
            <div class="col-4 col-sm-5 col-md-5 col-lg-5 box-logo">
               <img  class="pt-4" [src]="'UrlLogo' | templateText" alt="">
            </div>
         </div>
      </div>
   </div>
</div>
